<template>
    <div class="DM_transctionList">
        <!-- 交易明细 -->
        <el-card class="box-card" shadow="hover">
            <el-form :inline="true" :model="transctionForm" class="demo-form-inline">
                <el-form-item style="width:187px;">
                    <el-radio v-model="transctionForm.type" :label="1" @change="typeChange">团队</el-radio>
                    <el-radio v-model="transctionForm.type" :label="2" @change="typeChange">直营</el-radio>
                </el-form-item>
                <el-form-item>
                    <el-select
                        size="medium"
                        v-model="transctionForm.brand_id"
                        filterable
                        clearable
                        style="width:100%"
                        placeholder="终端类型"
                    >
                        <el-option
                            v-for="(item,index) in brandList"
                            :key="index"
                            :label="item.name"
                            :value="item.id"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-input size clearable v-model="transctionForm.sn" placeholder="SN码"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input
                        size
                        clearable
                        v-model="transctionForm.merchant_number"
                        placeholder="商户编号"
                    ></el-input>
                </el-form-item>
                <el-form-item>
                    <el-select
                        size="medium"
                        v-model="transctionForm.pay_type"
                        filterable
                        clearable
                        style="width:100%"
                        placeholder="交易方式"
                    >
                        <el-option
                            v-for="(item,index) in payTypeList"
                            :key="index"
                            :label="item.name"
                            :value="item.id"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-select
                        size
                        v-model="transctionForm.card_type"
                        clearable
                        placeholder="卡类型"
                    >
                        <el-option label="借记卡" value="1"></el-option>
                        <el-option label="贷记卡" value="2"></el-option>
                    </el-select>
                </el-form-item>
                <!-- <el-form-item>
                    <el-input style="width: 250px;"
                        size
                        clearable
                        v-model="transctionForm.company"
                        placeholder="代理商注册手机号"
                    ></el-input>
                </el-form-item> -->
                <el-form-item>
                	<el-input size clearable v-model="transctionForm.phone" placeholder="请输入直属代理商账号"></el-input>
                </el-form-item>
                
                <el-form-item>
                	<el-input size clearable v-model="transctionForm.agent_no" placeholder="请输入直属代理商编号"></el-input>
                </el-form-item>
                <el-form-item v-if="level < 2">
                	<el-input size clearable v-model="transctionForm.p2_phone" placeholder="请输入所属代理商账号"></el-input>
                </el-form-item>
                
                <el-form-item v-if="level < 2">
                	<el-input size clearable v-model="transctionForm.p2_agent_no" placeholder="请输入所属代理商编号"></el-input>
                </el-form-item>
				<el-form-item>
					<el-select size="medium" v-model="transctionForm.terminal_type" filterable clearable style="width:100%"
						placeholder="请选择终端类型">
						<el-option label="银盛POS" value="1"></el-option>
						<el-option label="手机POS" value="2"></el-option>
						<el-option label="杉德POS" value="3"></el-option>
						<el-option label="联动POS" value="4"></el-option>
                        <el-option label="海科POS" value="5"></el-option>
                        <el-option label="银盛尊享POS" value="6"></el-option>
					</el-select>
				</el-form-item>
                <el-form-item>
					<el-select size="medium" v-model="transctionForm.is_th" @change="changeIsTh" @clear="clearChangeIsTh" filterable clearable style="width:100%"
						placeholder="请选择渠道交易方式">
						<el-option v-for="(item,index) in is_th_op" :label="item.text" :value="item.key"></el-option>
					</el-select>
				</el-form-item>
                <el-form-item>
					<el-select size="medium" v-model="transctionForm.channel_pay_type"  v-show="is_ch_p_type_show"  filterable clearable style="width:100%"
						placeholder="请选择交易卡类型">
						<el-option v-for="(item,index) in channel_type_op" :label="item.text" :value="item.key"></el-option>
					</el-select>
				</el-form-item>
				<el-form-item>
				    <el-date-picker
				        v-model="rangeDate"
				        type="daterange"
				        range-separator="至"
				        start-placeholder="交易开始日期"
				        end-placeholder="交易结束日期"
				        value-format="yyyy-MM-dd"
				        :picker-options="pickerOptions"
				        @change="pickerChange"
				    ></el-date-picker>
				</el-form-item>
                <el-form-item>
                    <el-button
                        size="medium"
                        type="primary"
                        icon="el-icon-search"
                        style="font-size: 12px;"
                        @click="handleSearch(transctionForm)"
                    >查询</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button
                        size="small"
                        type="primary"
                        icon="el-icon-download"
                        :loading="downLoading"
                        @click="handleDownLoad(transctionForm)"
                    >导出数据</el-button>
                </el-form-item>
            </el-form>
        </el-card>
        <!-- 表格部分 -->
        <el-card class="box-card" style="margin-top: 20px;" shadow="hover">
            <div style="margin-bottom: 10px;">
                <div class="tableTitle">
                    <span class="st-label">交易总额：</span>
                    <span class="st-word-aux">{{tableTitle.money_count}}</span>
                </div>
                <div class="tableTitle">
                    <span class="st-label">交易笔数：</span>
                    <span class="st-word-aux">{{tableTitle.count}}&nbsp;笔</span>
                </div>
            </div>
            <el-table
                :data="transctionTable"
                size="mini"
                border
                style="width: 100%"
                v-loading="loading"
            >
                <!-- id -->
                <el-table-column
                    header-align="center"
                    align="center"
                    fixed
                    type="index"
                    label="ID"
                    min-width="80"
                ></el-table-column>
                <!-- 订单号 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="transaction_number"
                    label="订单号"
                    min-width="250"
                ></el-table-column>
                <!-- 终端类型 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="brand_name"
                    label="政策"
                    min-width="200"
                ></el-table-column>
                <!-- SN码 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="terminal_sn"
                    label="SN码"
                    min-width="190"
                ></el-table-column>
				<el-table-column header-align="center" align="center" prop="terminal_channel" label="终端类型"
					min-width="100"></el-table-column>
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="real_name"
                    :label="level > 1 ? '终端所属团队名称' : '终端直属代理名称'"
                    min-width="150"
                ></el-table-column>
                <!-- 终端归属代理手机号 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="phone"
                    :label="level > 1 ? '终端所属团队手机号' : '终端直属代理手机号'"
                    min-width="150"
                >
                </el-table-column>
                <!-- 终端归属代理编号 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="agent_no"
                    :label="level > 1 ? '终端所属团队编号' : '终端直属代理编号'"
                    min-width="150"
                >
                </el-table-column>
                <el-table-column v-if="level < 2" header-align="center" align="center" prop="p2_nickname" label="终端所属代理昵称"
                	min-width="150"></el-table-column>
                <el-table-column v-if="level < 2"  header-align="center" align="center" prop="p2_phone" label="终端所属代理账号" min-width="150">
                </el-table-column>
                <!-- 所属代理商编号 -->
                <el-table-column v-if="level < 2"  header-align="center" align="center" prop="p2_agent_no" label="终端所属代理编号" min-width="150">
                </el-table-column>
                <!-- 商户号 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="merchant_number"
                    label="商户号"
                    min-width="150"
                ></el-table-column>
                
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="merchant_name"
                    label="商户名称"
                    min-width="150"
                ></el-table-column>
                
                <!-- 交易类型 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="pay_type"
                    label="交易类型"
                    min-width="150"
                ></el-table-column>
                <!-- 卡类型 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="card_type_text"
                    label="卡类型"
                    min-width="60"
                ></el-table-column>
                <!-- 结算周期 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="settle_type"
                    label="结算周期"
                    min-width="120"
                    :formatter="formatSettle"
                ></el-table-column>
                <!-- 交易时间 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="transaction_time"
                    label="交易时间"
                    min-width="150"
                ></el-table-column>
                <!-- 交易金额 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="transaction_money"
                    label="交易金额"
                    min-width="120"
                ></el-table-column>
                <el-table-column
                    v-if="level == 0"
                    header-align="center"
                    align="center"
                    prop="is_give_up_profit_text"
                    label="是否让利交易"
                    min-width="120"
                ></el-table-column>
                <!-- 终端交易费率 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="terminal_rate"
                    label="终端交易费率"
                    min-width="150"
                >
                <template slot-scope="scope">
                    <span>{{scope.row.terminal_rate}} + {{scope.row.sec_fee}}</span>
                	
                </template>
                </el-table-column>
                <el-table-column
                    v-if="level == 0"
                    header-align="center"
                    align="center"
                    prop="terminal_rate"
                    label="商户实际费率"
                    min-width="150"
                >
                <template slot-scope="scope">
                    <span v-if="scope.row.real_base_rate">{{scope.row.real_base_rate}}+ </span><span  v-if="scope.row.real_base_sec_fee">{{scope.row.real_base_sec_fee}}</span>
                	
                </template>
                </el-table-column>
                <!-- 单笔秒到手续费 -->
                <!-- <el-table-column
                    header-align="center"
                    align="center"
                    prop="sec_fee"
                    label="单笔手续费"
                    min-width="100"
                ></el-table-column> -->
                <!-- 交易分润 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="income"
                    label="交易分润"
                    min-width="80"
                ></el-table-column>
                <!-- 交易费率类型 -->
                <el-table-column
                    v-if="level == 0"
                    header-align="center"
                    align="center"
                    prop="is_deal_agent_text"
                    label="涨价费率类型"
                    min-width="180"
                >
                <template slot-scope="scope">
                    <template v-if="scope.row.is_plat_up == 2 && scope.row.is_deal_agent == 1">
                        <div>正常交易</div>
                    </template>
                    
                    
                    <div v-if="scope.row.is_deal_agent == 3">
                        自由调价：{{scope.row.free_rate_up_type_text}}
                    </div>
                    
                    <template else-if>
                        <div v-if="scope.row.is_plat_up == 1">平台调价：{{scope.row.platform_rate_up_type_text}}</div>    
                    </template>
                    
                    
                	
                </template>
                </el-table-column>
                
                
                <el-table-column
                    v-if="level > 0"
                    header-align="center"
                    align="center"
                    prop="is_deal_agent_text"
                    label="费率类型"
                    min-width="180"
                >
                <template slot-scope="scope">
                    <template v-if="scope.row.is_plat_up == 2 && scope.row.is_deal_agent == 1">
                        <div>正常交易</div>
                    </template>
                    
                    
                    <div v-if="scope.row.is_deal_agent == 3">
                        自由调价
                    </div>
                    
                    <template else-if>
                        <div v-if="scope.row.is_plat_up == 1">平台调价</div>    
                    </template>
                </template>
                </el-table-column>
                
                <!-- 操作 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    fixed="right"
                    label="操作"
                    min-width="180"
                >
                    <template slot-scope="scope">
                        <el-button @click="handleInfo(scope.row)" type="text" size="small" v-if="scope.row.activity_type != 2 && level == 0 || level == 1">查看</el-button>
                        <!-- <el-button @click="handleInfos(scope.row)" type="text" size="small">查询出款状态</el-button> -->
						<span v-if="scope.row.activity_type == 2">押金无分润</span>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页部分 -->
            <paginations
                :currentPage="page.currentPage"
                :pageSize="page.pageSize"
                :total="page.total"
                @watchCurrent="getCurrent"
                @watchPageSize="getPageSize"
            ></paginations>
        </el-card>
        <transaction-info
            v-if="infoIsShow"
            :infoIsShow="infoIsShow"
            :detail="detail"
            @infoClose="infoClose"
        ></transaction-info>
        <transaction-status
            v-if="statusIsShow"
            :statusIsShow="statusIsShow"
            :detail="detail"
            @infoClose="infoClose"
        ></transaction-status>
    </div>
</template>

<script>
import paginations from '../../../components/pagination/paginations';
import transactionInfo from './DM_transctionInfo'
import transactionStatus from './DM_transactionStatus'
export default {
    name: "DM_transctionList",
    data() {
        return {
            tableTitle: {
                count: 0,
                money_count: 0
            },
            currentDate: '',
            pickerOptions: {},
            infoIsShow: false, //弹窗
            statusIsShow: false, //弹窗
            detail: {}, //当前行
            brandList: [], //终端类型列表
            payTypeList: [], //支付类型
            rangeDate: [], //时间范围
            transctionForm: {
                sn: '',  //sn码
                phone: '', //归属代理账号
                pay_type: '', //交易方式
                brand_id: '', //终端类型id
                card_type: '', //卡类型
                agent_id:'',//所属代理商
                real_name: '', //归属代理名称
                company: '', //d代理商公司名称
                end_time: '', //交易结束日期
                start_time: '', //交易开始日期
                terminal_number: '', //终端编号
                merchant_number: '', //商户编号
                transaction_number: '', //订单号
				terminal_type:'',
                type: 1, //默认团队交易
                page: 1,
                limit: 10,
                is_th:'',  //渠道交易方式
                channel_pay_type:'', //交易卡类型 
                p2_phone:'',
                p2_agent_no:'',
                agent_no:''
            },
            transctionTable: [],
            page: {
                currentPage: 1, //当前页码
                pageSize: 10, //条数
                total: 0  //总数
            },
            loading: true,
            downLoading: false, //导出loading
            level: sessionStorage.getItem('level'),
            is_th_op:[
                {'key':'1','text':'正常'},
                {'key':'2','text':'正常_特惠'}
            ],
            channel_type_op:[],
            card_type_op:[
                {'key':'1','text':'借记卡'},
                {'key':'2','text':'贷记卡'},
            ],
            pay_type_op:[  //贷记卡+广发贷记卡+平安贷记卡+民生贷记卡
                {'key':'1','text':'贷记卡'},
                {'key':'2','text':'广发贷记卡'},
                {'key':'3','text':'平安贷记卡'},
                {'key':'4','text':'民生贷记卡'},
            ],
            is_ch_p_type_show:false, //交易卡类型显示与隐藏 

        }
    },
    created() {
        this.pickerOptions.disabledDate = (time) => { //禁用日期
            if (this.currentDate !== '') {
                let tempTime = 3600 * 1000 * 24 * 30 * 3;
                let timer = new Date(this.currentDate).getTime();
                let minTime = timer - tempTime;
                let maxTime = timer + tempTime;
                return time.getTime() < minTime || time.getTime() > Date.now() || time.getTime() > maxTime;
            }
            return time.getTime() > Date.now();
        }
        this.pickerOptions.onPick = ({ minDate, maxDate }) => { //当前选中的日期
            this.currentDate = minDate.getTime();
            if (maxDate) {
                this.currentDate = '';
            }
        }
    },
    mounted() {
        this.handleDefaultTime();
        this.$api.post('brand/brand_list', {}, res => { //获取终端类型
            if (res.code == 0) {
                this.brandList = res.data.list;
            } else {
                this.$message.success(res.msg);
            }
        });
        this.$api.post('type/pay_type', {}, res => { //获取支付类型
            if (res.code == 0) {
                this.payTypeList = res.data;
            } else {
                this.$message.success(res.msg);
            }
        });
        this.getData(this.transctionForm);//初始化
    },
    components: {
        paginations,
        transactionInfo,
        transactionStatus
    },
    methods: {
        typeChange(val) { //监听radio
            this.transctionForm.type = val;
            this.page.currentPage = 1; //重置分页
            this.transctionForm.page = 1; //重置
            // 表单提交
            this.getData(this.transctionForm);
        },
        handleSearch(transctionForm) {
            this.page.currentPage = 1; //重置分页
            this.transctionForm.page = 1; //重置
            // 表单提交
            this.getData(transctionForm);
        },
        handleInfo(row) { //查看
            this.infoIsShow = true;
            this.detail = row;
        },
        handleInfos(row) { //查看
            this.statusIsShow = true;
            this.detail = row;
        },
        infoClose() { //关闭弹窗
            this.infoIsShow = false;
            this.statusIsShow = false;
        },
        //分页
        getCurrent(page) {
            this.loading = true;
            // 获取当前页修改的值
            this.page.currentPage = page;
            this.transctionForm.page = this.page.currentPage;
            this.transctionForm.limit = this.page.pageSize;
            this.getData(this.transctionForm);
        },
        getPageSize(limit) {
            this.page.currentPage = 1; //重置分页
            // 获取条数发生改变的值
            this.loading = true;
            this.page.pageSize = limit;
            this.transctionForm.page = this.page.currentPage;
            this.transctionForm.limit = limit;
            this.getData(this.transctionForm);
        },
        getData(params) {
            this.$api.post("transaction/getList", params, res => {
                if (res.code == 0) {
                    let data = res.data;
                    let { count, list, money_count } = data;
                    this.page.total = count; //总数
                    this.transctionTable = list;
                    this.tableTitle = { count, money_count };
                } else {
                    this.$message.error(res.msg);
                }
                //渲染结束后取消加载
                this.loading = false;
            })
        },
        formatSettle(row) {
            let settle = ''; //1.T+0 2.T+1
            switch (row.settle_type) {
                case 1:
                    settle = 'T+0';
                    break;
                default:
                    settle = 'T+1';
                    break;
            }
            return settle;
        },
        formatCard(row) {
            let card = ''; //1.借记卡 2.贷记卡
            switch (row.card_type) {
                case 1:
                    card = '借记卡';
                    break;
                default:
                    card = '贷记卡';
                    break;
            }
            return card;
        },
        handleDownLoad(searchForm) { //导出
			let reqData = {
			    type: 1,
			    value: JSON.stringify(searchForm)
			};
			
			this.downLoading = true; 
			this.$api.post('export/add', reqData, res => {
			    if (res.code == 0) {
			        this.$message.success(res.msg);
					this.downLoading = false;
			    } else {
			        this.$message.error(res.msg);
					this.downLoading = false;
			    }

			})
        },
        handleDefaultTime() { //默认获取三十天
            let date =this.$moment().endOf('day').format('x');
            this.transctionForm.end_time = this.$moment(Number(date)).format("YYYY-MM-DD HH:mm:ss");
            this.transctionForm.start_time = this.$moment(Number(date) - 3600 * 1000 * 24 * 31 +1).format("YYYY-MM-DD HH:mm:ss");
            this.rangeDate = [this.transctionForm.start_time, this.transctionForm.end_time];
        },
        pickerChange(DateArr) { //时间选择器
            this.transctionForm.start_time = this._.isEmpty(DateArr) ? '' : DateArr[0];
            this.transctionForm.end_time = this._.isEmpty(DateArr) ? '' : this.$moment(Number(this.$moment(DateArr[1]).endOf('day').format('x'))).format("YYYY-MM-DD HH:mm:ss");
            this.rangeDate = [this.transctionForm.start_time, this.transctionForm.end_time];
        },
        //渠道交易方式 交易卡类型 联动 
        changeIsTh(val){
            this.transctionForm.channel_pay_type = '';
            this.is_ch_p_type_show = true;
            if(val == 1){
                this.channel_type_op = this.card_type_op;
            }else{
                this.channel_type_op = this.pay_type_op;
            }
        },
        //捕获渠道交易方式取消按钮 
        clearChangeIsTh(){
            this.is_ch_p_type_show = false;
            this.channel_type_op =[];
        }

    },
};
</script>

<style lang="scss" scope>
.DM_transctionList {
    .el-input__inner {
        font-size: 12px;
    }
    .el-form-item {
        margin-bottom: 5px;
    }
    .tableTitle {
        display: inline-block;
        margin-right: 20px;
    }
}
</style>
